webpackJsonp([263791100135453],{

/***/ 47:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _about = __webpack_require__(47);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        'div',
	        { id: 'about-page' },
	        _react2.default.createElement(
	            'section',
	            { className: 'pageHeader', id: 'about-header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container py-5' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'About Us'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container small-container text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 text-left ' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'The Start'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A software development company founded in Kent UK by a team of creative designers & skilled developers.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 text-right ' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Our Product'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We develop for the web, iOS, Android & Windows.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 text-left ' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Our Quality'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Over time we have assembled a compact but powerful team of developers who aim to create nothing short of beautiful products.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-e321bb5537bc373ab0a2.js